module.exports = __webpack_public_path__ + "img/r_movie.a302e4b0.png";